/**
 * מספרים בפורמט E.164 בכל מקום (+9725XXXXXXXX).
 * הממשק מקבל 05X ומנרמל (מסמך התכנון, סעיף 7.1).
 */
const DEFAULT_COUNTRY_CODE = '972';

export function normalizePhone(input: string, countryCode = DEFAULT_COUNTRY_CODE): string | null {
  const digits = input.replace(/[^\d+]/g, '');
  if (!digits) return null;

  let local = digits;
  if (local.startsWith('+')) local = local.slice(1);
  if (local.startsWith('00')) local = local.slice(2);
  if (local.startsWith(countryCode)) local = local.slice(countryCode.length);
  if (local.startsWith('0')) local = local.slice(1);

  if (!/^\d{8,9}$/.test(local)) return null;
  return `+${countryCode}${local}`;
}

export function isValidPhone(input: string): boolean {
  return normalizePhone(input) !== null;
}

/** לתצוגה לעובד: 050-123-4567 */
export function formatPhone(e164: string): string {
  const match = /^\+972(\d{2})(\d{3})(\d{4})$/.exec(e164);
  if (!match) return e164;
  return `0${match[1]}-${match[2]}-${match[3]}`;
}

/** ללוגים בלבד: 05X***1234 (מסמך התכנון, סעיף 10). */
export function maskPhone(e164: string): string {
  const digits = e164.replace(/\D/g, '');
  if (digits.length < 6) return '***';
  return `05X***${digits.slice(-4)}`;
}
